module.exports = __webpack_public_path__ + "img/widget_PC.78b15e7b.png";